<ng-container *ngIf="!!customizationError; else noError">
    <div class="error-container">
        <span>Une erreur est survenue, veuillez réessayer.</span>
    </div>
</ng-container>
<ng-template #noError>
    <ng-container *ngIf="!!customization; else noCustomization">
        <div class="fake-customization-header" [ngClass]="{'smallscreen': displayType === 'smallScreen', 'miniscreen': displayType === 'miniScreen'}">
            <div class="dots-container">
                <div class="dots"></div>
                <div class="dots"></div>
                <div class="dots"></div>
            </div>
            <div class="url-container">
                <span class="url">
                    <ng-container *ngIf="customizationAim === 'receiver'; else sender">
                        https://{{url}}/{{'CUSTOMIZATION_URL_EXAMPLE_MY_TRANSFER' | translate }}
                    </ng-container>
                    <ng-template #sender>
                        https://{{url}}
                    </ng-template>
                </span>
            </div>
        </div>
        <div class="content" appElementResize disabled="displayType === 'miniScreen'">

            <!-- PREVIEW CUSTOMIZATION TRANSFER PARAMS -->
            <ng-container *ngIf="displayType === 'miniScreen'; else notMiniScreen">
                <ng-container *ngIf="!!customization.background; else noBackground">
                    <!-- Image background -->
                    <div class="container-background" *ngIf="!!customization.background && customization.background.type === 'Image'"
                        appBackgroundImage="{{ customization.background.sourceUrl }}" (imageLoading)="displayLoadingSpinner()"
                        (readyToDisplayImage)="hideLoadingSpinner()" appElementResize>
                    </div>
                    <!-- Youtube && Vimeo thumbnail -->
                    <div class="container-background"
                        *ngIf="!!customization.background && customization.background.type === 'Youtube' || customization.background.type === 'Vimeo'"
                        appBackgroundImage="{{ customization.background.thumbnail }}" (imageLoading)="displayLoadingSpinner()"
                        (readyToDisplayImage)="hideLoadingSpinner()" appElementResize>
                        <i class="icon-smash_videos icon-video"></i>
                    </div>
                </ng-container>
                <ng-template #noBackground>
                    <div class="placeholder-no-content"></div>
                </ng-template>
            </ng-container>

            <ng-template #notMiniScreen>
                <!-- FULL SCREEN CUSTOMIZATION -->
                <ng-container *ngIf="displayType !== 'miniScreen'">
                    <!-- Smash logo  -->
                    <i class="icon-smash_logo_no_chip smash-logo" [ngClass]="{'fullscreen': displayType === 'fullscreen'}"
                        *ngIf="displayType !== 'miniScreen'"></i>
                    <!-- Burger Menu -->
                    <i class="icon-smash_menu smash-menu" [ngClass]="{'fullscreen': displayType === 'fullscreen'}"
                        *ngIf="displayType !== 'miniScreen'"></i>
                    <!-- BACKGROUNDS -->
                    <ng-container *ngIf="!!customization.background; else noBackground">
                        <!-- Image backkround -->
                        <div class="container-background" *ngIf="!!customization.background && customization.background.type === 'Image'"
                            appBackgroundImage="{{ customization.background.sourceUrl }}" (imageLoading)="displayLoadingSpinner()"
                            (readyToDisplayImage)="hideLoadingSpinner()" appElementResize>
                        </div>
                        <!-- Youtube/Vimeo background -->
                        <div class="content-video-background"
                            *ngIf="!!customization.background && (customization.background.type === 'Youtube' || customization.background.type === 'Vimeo')">
                            <div class="content-video-foreground">
                                <app-smash-player [source]="playerSource" [options]="playerOptions" (loading)="displayLoadingSpinner()"
                                    (readyToPlay)="hideLoadingSpinner()" [allowConcurrency]="true"></app-smash-player>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noBackground>
                        <div class="placeholder-no-content"></div>
                    </ng-template>
                </ng-container>
            </ng-template>

            <!-- div to prevent video click -->
            <div class="content-overlay" *ngIf="loadingSpinnerDisplayed" [ngClass]="{'content-overlay-loading': loadingSpinnerDisplayed}">
                <div class="loading-spinner-container">
                    <div class="loading-spinner-grey"></div>
                </div>
            </div>

            <!-- COMMON TOOLTIP CENTER -->
            <div class="content-centered">
                <ng-container *ngIf="!!customization.logo; else noLogo">
                    <div class="content-tooltip-wrapper" appElementProportionalResize>
                        <div class="content-tooltip-container" [ngClass]="{'smallScreen': displayType === 'smallScreen'}">
                            <app-smash-tooltip position="top" [delay]="delay" displayed="true" class="smash-tooltip">
                                <ng-container *ngIf="customizationAim === 'receiver'; else uploaderTooltip">
                                    <div class="line1" translate>CUSTOMIZATION_TOOLTIP_CLICK_TO_DOWNLOAD</div>
                                    <div class="line2" translate>CUSTOMIZATION_TOOLTIP_SMASH_TITLE</div>
                                    <!-- Switch tooltip text container -->
                                    <div class="line3">
                                        <div [ngClass]="{'visible':  currentState === 'out'}">
                                            {{ 'CUSTOMIZATION_TOOLTIP_EXAMPLE_SIZE' | translate }} - {{ 'CUSTOMIZATION_TOOLTIP_EXAMPLE_FILE_NUMBER' |
                                            translate }}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #uploaderTooltip>
                                    <span [innerHtml]="'UPLOADER_PUNCHLINE' | translate | safeHtml"></span>
                                </ng-template>
                            </app-smash-tooltip>

                        </div>
                        <div class="content-center-container">
                            <div class="content-spinner-container"
                                [ngClass]="{'smallScreen': (displayType === 'smallScreen'), 'miniScreen': (displayType === 'miniScreen')}">
                                <app-smash-spinner [url]="customization.logo.thumbnail" (imageLoading)="displayLoadingSpinner()"
                                    (readyToDisplayImage)="hideLoadingSpinner()">
                                </app-smash-spinner>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noLogo>
                    <div class="content-tooltip-wrapper" appElementProportionalResize>
                        <div class="content-tooltip-container" [ngClass]="{'smallScreen': displayType === 'smallScreen'}">
                            <app-smash-tooltip position="top" [delay]="delay" displayed="true" class="smash-tooltip">
                                <ng-container *ngIf="customizationAim === 'receiver'; else uploaderTooltip">
                                    <div class="line1" translate>CUSTOMIZATION_TOOLTIP_CLICK_TO_DOWNLOAD</div>
                                    <div class="line2" translate>CUSTOMIZATION_TOOLTIP_SMASH_TITLE</div>
                                    <!-- Switch tooltip text container -->
                                    <div class="line3">
                                        <div [ngClass]="{'visible':  currentState === 'out'}">
                                            {{ 'CUSTOMIZATION_TOOLTIP_EXAMPLE_SIZE' | translate }} - {{ 'CUSTOMIZATION_TOOLTIP_EXAMPLE_FILE_NUMBER' |
                                            translate }}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #uploaderTooltip>
                                    <span [innerHtml]="'UPLOADER_PUNCHLINE' | translate | safeHtml"></span>
                                </ng-template>
                            </app-smash-tooltip>

                        </div>
                        <div class="content-center-container">
                            <div class="content-spinner-container"
                                [ngClass]="{'smallScreen': (displayType === 'smallScreen'), 'miniScreen': (displayType === 'miniScreen')}">
                                <app-smash-spinner [url]="logoFallback.thumbnail" (imageLoading)="displayLoadingSpinner()"
                                    (readyToDisplayImage)="hideLoadingSpinner()">
                                </app-smash-spinner>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <app-smash-manufacture class="smash-manufacture" [ngClass]="{'smallScreen': displayType === 'smallScreen'}"
                *ngIf="displayType !== 'miniScreen'">
            </app-smash-manufacture>
        </div>
    </ng-container>
    <ng-template #noCustomization>
        <div class="loading-spinner-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-template>
</ng-template>